import React, {useState, useEffect} from "react";
import { Dropdown } from "react-bootstrap";

import cx from "classnames";
import _ from "lodash";
import styles from "./monthPicker.module.scss";
import { Checkbox } from "src/components/input";

interface MonthPickerProps {
  selectedMonth: string | null;
  // eslint-disable-next-line no-unused-vars
  onPick: (month: string) => void;
}

export const MonthPicker: React.FC<MonthPickerProps> = ({ selectedMonth, onPick }) => {
  const [open, setOpen] = useState<boolean>(false);

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const handleDropdownClick = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    setOpen(!open);
  };

  const onSelect = (month) => {
    onPick(month);
    setOpen(false);
  };

  return (
    <Dropdown
      className={styles.selectDropdown}
      show={open}
      onToggle={(isOpen) => {
        if (!isOpen) {
          setOpen(isOpen);
        }
      }}
    >
      <Dropdown.Toggle variant="primary" id={`dropdown`}>
        <div className={styles.filterToggle} onClick={handleDropdownClick}>
          <span className={styles.filter}>insights monthly view - </span>
          <span className={styles.selected}>{selectedMonth}</span>
          <i className={cx("paperflite-dropdown", styles.icon)} />
        </div>
      </Dropdown.Toggle>
      <Dropdown.Menu
        align="end"
        popperConfig={{
          modifiers: [
            {
              name: "offset",
              options: {
                offset: [0, 6],
              },
            },
          ],
        }}
      >
        {months.map((item) => {
          const isSelected = selectedMonth === item;
          return (
            <Dropdown.Item
              key={item}
              className={cx(styles.item)}
              onClick={() => onSelect(item)}
            >
              <Checkbox checked={isSelected} onChange={() => onSelect(item)} />
              <span>{item} </span>
            </Dropdown.Item>
          );
        })}
      </Dropdown.Menu>
    </Dropdown>
  );
};
